import Icon, { IconName } from "@components/common/Icon"

interface IProps {
  className?: string
  children?: React.ReactNode
  icon?: IconName
}

/**
 * provides a StatusIndicator, used for project states
 */
const StatusIndicator: React.FC<IProps> = ({ className, children, icon }: IProps) => {
  const finalClassName = ["d-flex align-items-center", className || ""].join(" ").trim()

  return <div className={finalClassName}>
    {icon
      ? <Icon name={icon} size={20} />
      : <Icon name="circle" size={16} />
    }
    <span className="ml-1">{children}</span>
  </div>
}

export default StatusIndicator
